import { SVGProps } from 'react';

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="5.5" cy="5.5" r="5.1" stroke="#6C6B6B" strokeWidth="0.8" />
            <path
                d="M5.04036 8.24967C4.75391 8.24967 4.58203 8.07913 4.58203 7.82332V5.00936C4.58203 4.75355 4.75391 4.58301 5.04036 4.58301C5.32682 4.58301 5.95703 4.78553 5.95703 5.04134V7.33301C5.89974 7.58882 5.26953 8.24967 5.04036 8.24967Z"
                fill="#6C6B6B"
            />
            <path
                d="M5.04036 3.66667C4.75391 3.66667 4.58203 3.48333 4.58203 3.23889C4.58203 2.93333 4.75391 2.75 5.04036 2.75C5.32682 2.75 5.95681 2.90278 5.95681 3.20833C5.95681 3.51389 5.26953 3.66667 5.04036 3.66667Z"
                fill="#6C6B6B"
            />
        </svg>
    );
};
